import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import {
  successResellerLicenseList,
  errorResellerLicenseList,
  successDeleteLicense,
  errorDeleteLicense,
  successUpdateLicense,
  errorUpdateLicense,
  errorLicenseSet,
  successLicenseSet,
  setRlienseDetailsById,
  setRlicenseDetailsErrorById,
  successResellerLicenseItem,
  errorResellerLicenseItem,
  setLicenseSummary,
  setLicenseSummaryError,
  successResellerLicenseCustomerView,
  errorResellerLicenseCustomerView,
} from "../actions";
import {
  fetchResellerLicenseList,
  deleteLicenseApi,
  updateLicenseApi,
  createResellerLicense,
  getRlicenseDetailsByID,
  fetchlicenseSummary,
  fetchResellerLicenseCustomerView,
  } from "../api/resellerLicense";
import { resellerLicense } from "../../constants/actionTypes";
import { statusCode } from "../../constants/apis/apiStatus";
import { toasterFlags } from "../../constants/componentConstants";
import { toastNotification } from "../../utils/toast";

export function* getResellerLicenseListFunction({ payload }) {
  try {
    const data = yield call(fetchResellerLicenseList, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successResellerLicenseList(data?.data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorResellerLicenseList, data);
    }
  } catch (err) {
    yield put(errorResellerLicenseList, err);
  }
}

export function* getResellerLicenseClientViewFunction({ payload }) {
  try {
    const data = yield call(fetchResellerLicenseCustomerView, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successResellerLicenseCustomerView(data?.data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorResellerLicenseCustomerView, data);
    }
  } catch (err) {
    yield put(errorResellerLicenseList, err);
  }
}

export function* deleteLicenseFunction({ payload }) {
  try {
    const data = yield call(deleteLicenseApi, payload);
    if (data?.status === statusCode.Ok200) {
      toastNotification(toasterFlags.SUCCESS, "License Deleted Successfully....");
      yield put(successDeleteLicense(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorDeleteLicense(data));
    }
  } catch (err) {
    yield put(errorDeleteLicense(err));
  }
}

export function* updateLicenseFunction({ payload, id }) {
  try {
    const data = yield call(updateLicenseApi, id, payload);
      if (data?.status === statusCode.Ok200) {
      yield put(successUpdateLicense(data));
      toastNotification(toasterFlags.SUCCESS,"Record Updated successfully")
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorUpdateLicense(data));
    }
  } catch (err) {
    yield put(errorUpdateLicense(err));
  }
}

export function* createLicenseFunction({ payload }) {
  try {
    const data = yield call(createResellerLicense, payload);
    if (data?.status === statusCode.Created201) {
      yield put(successLicenseSet(data));
      toastNotification(toasterFlags.SUCCESS, "License Created successfully....");
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorLicenseSet(data));
    }
  } catch (err) {
    yield put(errorLicenseSet(err));
  }
}
export function* getRlicenseDetails({ payload }) {
  try {
    const data = yield call(getRlicenseDetailsByID, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successResellerLicenseItem(data?.data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorResellerLicenseItem(data));
    }
  } catch (err) {
    yield put(errorResellerLicenseItem(err));
  }
}

export function* getLicenseSummaryFunction({payload}){
  try {
    const response = yield call(fetchlicenseSummary, payload);
      if (response?.status === statusCode.Ok200) {
      yield put(setLicenseSummary(response?.data));
    } else {
      yield put(setLicenseSummaryError(response));
      toastNotification(toasterFlags.WARN, `${response?.data?.error}`);
    }
  } catch (error) {
    yield put(setLicenseSummaryError(error));
  }
}


export function* resellerLicenseWatcherSaga() {
  yield takeLatest(resellerLicense?.GET_RESELLERLICENSE_LIST, getResellerLicenseListFunction);
  yield takeLatest(resellerLicense?.GET_RESELLERLICENSE_CUSTOMER_VIEW, getResellerLicenseClientViewFunction);
  yield takeLatest(resellerLicense?.REQUEST_DELETE_LICENSE, deleteLicenseFunction);
  yield takeLatest(resellerLicense?.REQUEST_UPDATE_LICENSE, updateLicenseFunction);
  yield takeLatest(resellerLicense?.GET_RESELLERLICENSE_LIST_BYID, getRlicenseDetails);
  yield takeLatest(resellerLicense?.GET_LICENSE_SUMMARY, getLicenseSummaryFunction);
  yield takeLatest(resellerLicense?.REQUEST_SET_LICENSE, createLicenseFunction);
}

export default function* resellerLicenseSaga() {
  yield all([fork(resellerLicenseWatcherSaga)]);
}
